import React, { Component } from "react";
import moment from "moment";

import constants from "../constants";
import homeIcon from "../img/icons/home.svg";
import politicsIcon from "../img/icons/politics.svg";
import scienceIcon from "../img/icons/science.svg";
import businessIcon from "../img/icons/business.svg";
import settingsIcon from "../img/icons/settings.svg";

import "./sidebar.scss";

class Sidebar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentTime: moment(),
      section: "Home",
    };
  }

  componentDidMount() {
    setInterval((e) => {
      this.setState({
        currentTime: moment(),
      });
    }, 1000);
  }

  render() {
    const sections = [
      {
        name: "Home",
        icon: homeIcon,
      },
      {
        name: "Politics",
        icon: politicsIcon,
      },
      {
        name: "Science",
        icon: scienceIcon,
      },
      {
        name: "Business",
        icon: businessIcon,
      },
    ];

    return (
      <div className="Sidebar">
        <div className="header">
          <h1>Newsly</h1>
          <span className="flag" role="img" aria-label="Thailand flag">
            &#127481;&#127469;
          </span>
        </div>
        <div className="date">
          <h2>{this.state.currentTime.format("ll")}</h2>
          <h3>{this.state.currentTime.format("LT")}</h3>
        </div>
        <div className="sections">
          {sections.map((section) => (
            <div
              className={
                "section-item" +
                (this.state.section === section.name ? " selected" : "")
              }
              key={section.name}
              onClick={() => {
                this.setState({
                  section: section.name,
                });
              }}
            >
              <img src={section.icon} alt={section.name + " Icon"} />
              <span>{section.name}</span>
            </div>
          ))}
        </div>
        <img
          src={settingsIcon}
          className="settings-button"
          onClick={() => this.props.onDisplayPopup(constants.popup.settings)}
          alt="Click to open settings"
        />
      </div>
    );
  }
}

export default Sidebar;
